<template>
    <div>
        <!-- filter component -->
        <div class="d-flex align-center">
            <v-btn
                tile
                depressed
                color="grey lighten-3"
                class="rounded-l text-none"
                @click.stop="showDialog()"
            >
                <span class="mr-2">Filter</span>
                <v-icon>mdi-sort-variant</v-icon>
            </v-btn>
            <span style="width:400px">
                <v-text-field
                    v-model="search"
                    dense
                    outlined
                    hide-details
                    prepend-inner-icon="mdi-magnify"
                    placeholder="Search Doctors"
                    class="rounded-l-0 rounded-r"
                    @input="setFilters()"
                >
                </v-text-field>
            </span>
            <v-switch
                v-model="availableNextHour"
                dense
                hide-details
                color="success"
                height="10px"
                label="Available for the next 2-3 hrs"
                class="my-auto ml-10"
                @change="setFilters()"
            >
            </v-switch>
        </div>

        <!-- filter chips -->
        <div class="mt-2">
            <div v-if="selectedFilters.specializations.length  || selectedFilters.status.length">
                <span>
                    <v-chip
                        v-for="(specialization, key) in selectedFilters.specializations"
                        :key="key"
                        close
                        small
                        color="grey lighten-3 doctor-filter-chip--close"
                        close-icon="mdi-close"
                        class="mx-2 mt-2 pa-4"
                        @click:close="selectedFilters.specializations.splice(key, 1)"
                    >
                        {{ specialization }}
                    </v-chip>
                </span>
                <span>
                    <v-chip
                        v-for="(status, key) in selectedFilters.status"
                        :key="key"
                        close
                        small
                        color="grey lighten-3 doctor-filter-chip--close"
                        close-icon="mdi-close"
                        class="mx-2 mt-2 pa-4"
                        @click:close="selectedFilters.status.splice(key, 1)"
                    >
                        {{ status }}
                    </v-chip>
                </span>
            </div>
        </div>
        
        <!-- filter results -->
        <div class="mt-2">
            <span class="caption">{{ resultCount | resultCountText }}</span>
        </div>
        

        <v-dialog
            v-model="filterDialog"
            max-width="550px"
            persistent
        >
            <v-card>
                <v-card-title class="primary--text">
                    <span>Filter Search</span>
                    <v-icon
                        class="ml-auto"
                        @click="closeFilterDialog()"
                    >
                        mdi-close
                    </v-icon>
                </v-card-title>

                <v-card-text>
                    <div class="mx-4">
                        <h3 class="mb-2">Specialization</h3>
                        <v-row dense>
                            <v-col
                                cols="4"
                                v-for="(specialization, key) in specializations"
                                :key="key"
                                class="pa-0"
                            >
                                <v-checkbox
                                    v-model="cachedSelectedFilters.specializations"
                                    dense
                                    hide-details
                                    class="ma-0 py-2 text-wrap"
                                    :label="specialization"
                                    :value="specialization"
                                ></v-checkbox>
                            </v-col>
                        </v-row>
                    </div>
                    <div>
                        <h3 class="mt-4 mb-2">Status</h3>
                        <v-row dense>
                            <v-col
                                cols="4"
                                v-for="(status, key) in statuses"
                                :key="key"
                                class="pa-0"
                            >
                                <v-checkbox
                                    v-model="cachedSelectedFilters.status"
                                    dense
                                    hide-details
                                    class="ma-0 text-no-wrap"
                                    :label="status"
                                    :value="status"
                                ></v-checkbox>
                            </v-col>
                        </v-row>
                    </div>
                </v-card-text>

                <v-card-actions class="justify-center pb-6">
                    <v-btn
                        rounded
                        depressed
                        color="primary lighten-4 primary--text"
                        width="100px"
                        class="mx-3"
                        @click="cancelFilterDialog()"
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                        rounded
                        depressed
                        color="primary"
                        width="100px"
                        class="mx-3"
                        @click="getSelectedFilters()"
                    >
                        Filter
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    filters: {
        resultCountText(value) {
            if (value) {
                return `Showing ${value} result.`;
            }

            return "No result."
        }
    },
    props: {
        resultCount: {
            type: Number,
            default: 0
        }
    },
    data: () => ({
        search: "",
        availableNextHour: false,
        filterDialog: false,
        specializations: [
            'Cardiology',
            'Endocrinology',
            'Family Medicine',
            'Gastro',
            'Internal',
            'Pediatric',
            'OBGyn',
            'Anesthesiology',
            'General Practice',
            'General Surgery',
            'Ophthalmology',
            /**
             * newly added
             */
            'Hepato-Pancreato-Biliary/Liver Transplant Surgery Subspecialty',
            'GP (with Neuro Surg background)',
            'GP (with ENT background)',
            'FM (with OB background)',
            'Physician',
            'AMD on Medical Affairs',
            'Vice president of Medical Operations',
            'Medical Auditor',
            'Compliance Officer',
            'Training Officer',
            'AMD on Medical Operations',
        ],
        statuses: [
            'online',
            'in call',
            'acw',
            'on break'
        ],
        cachedSelectedFilters: {
            specializations: [],
            status: []
        },
        selectedFilters: {
            specializations: [],
            status: []
        }
    }),
    methods: {
        showDialog() {
            this.cachedSelectedFilters = this.cloneObject(this.selectedFilters);
            this.filterDialog = true;
        },
        closeFilterDialog() {
            this.filterDialog = false;
        },
        cancelFilterDialog() {
            this.resetSelectedFilters();

            this.setFilters();

            this.closeFilterDialog();
        },
        getSelectedFilters() {
            this.selectedFilters = this.cloneObject(this.cachedSelectedFilters);
            this.setFilters();
            this.closeFilterDialog();
        },
        setFilters() {
            this.$emit("setFilters", {
                name: this.search || null,
                specializations: this.selectedFilters.specializations || [],
                status: this.selectedFilters.status || [],
                availableNextHour: this.availableNextHour
            });
        },
        resetSelectedFilters() {
            this.selectedFilters = {
                specializations: [],
                status: []
            };
            this.cachedSelectedFilters = {
                specializations: [],
                status: []
            };
        },
        cloneObject(object) {
            /**
             * clone object to avoid referencing
             * 
             * example use case is when selecting items on dialog
             * chips are not updating
             */
            return JSON.parse(JSON.stringify(object));
        }
    }
}
</script>

<style lang="scss">
  // for properties that needs to be unscoped to worked

.doctor-filter-chip--close {
    button {
        color: red !important;
    }
}
</style>